module.exports = __webpack_public_path__ + "static/media/map.1106001e.png";